export default {
  // App Bar Actions
  app_bar_actions: {
    account_menu: {
      tooltip: "Детайли за профила",

      // Account Menu Card
      account_menu_card: {
        // Language Section
        language_section: {
          title: "Избиране на език",
          tooltip: "Избиране на предпочитан език",

          languages: {
            en: "Английски",
            bg: "Български",
            mk: "Македонски",
          },
        },

        // Theme Section
        theme_section: {
          title: "Избиране на тема",
          tooltip: "Избиране на тема на приложението",

          themes: {
            light: "Светла",
            dark: "Тъмна",
            auto: "Системна",
          },
        },

        // Sign Out
        sign_out: {
          title: "Изход",
          tooltip: "Излизане от приложението",
        },
      },
    },
  },

  // Drawer Toggle
  drawer_toggle: {
    open_tooltip: "Отваряне на менюто",
    rail_tooltip: "Разширяване на менюто",
    close_tooltip: "Затваряне на менюто",
  },

  // Page Titles
  page_titles: {
    channels: "Канали",
    instruments: "Апарати",
    locations: "Локации",
    validation: "Валидация",
    tests: "Тестове",
    about: "Относно",
    login: "Вход",
  },
};
